module.exports = __webpack_public_path__ + "img/green.b6ec3cab.png";